import React, { useEffect, useMemo, useState } from 'react';
import api from '../api/api';

/*
  ============================================================
  THEME CONFIGURATION
  ============================================================

  IMPORTANT:
  - Ab 5 frontend themes hain.
  - Theme 6/7 baad mein isi array mein add ki ja sakti hain.
  - SpinWheel.jsx isi exported THEMES configuration ko use karta hai.
  - Backend sirf active themeKey store karega.
  ============================================================
*/

export const THEMES = [
  {
    id: 1,
    key: 'theme-1',
    name: 'Theme 1',
    description: 'Professional Multi-Color Spin Wheel',

    wheelColors: [
      '#70c069',
      '#469ED7',
      '#EC1A75',
      '#FCB415',
      '#3F61AC',
      '#6ACBDF',
      '#EC1A24',
      'rgb(185, 196, 232)',
      'rgb(124, 181, 235)',
      '#6bf4f9',
    ],

    backgroundColor: '#33449A',
    patternBackground: '#33449A',

    backgroundText:
      'SPIN!  SPIN!  SPIN!  SPIN  SPIN SPIN SPIN',

    backgroundTextColor: '#FFFFFF',
    backgroundTextOpacity: 0.12,
    backgroundFontSize: '180px',
    backgroundRows: 3,
    backgroundTopSpacing: 35,
    animationDuration: 4,
    animationType: 'crazyShake',
  },

  {
    id: 2,
    key: 'theme-2',
    name: 'Theme 2',
    description: 'Premium Red & White Spin Wheel',

    wheelColors: [
      '#9E0000',
      '#FFFFFF',
      '#9E0000',
      '#FFFFFF',
      '#9E0000',
      '#FFFFFF',
      '#9E0000',
      '#FFFFFF',
      '#9E0000',
      '#FFFFFF',
    ],

    backgroundColor: '#33449A',
    patternBackground: '#686365',

    backgroundText:
      'LOGO! LOGO! LOGO! LOGO! LOGO! LOGO!',

    backgroundTextColor: '#FFFFFF',
    backgroundTextOpacity: 0.12,
    backgroundFontSize: '160px',
    backgroundRows: 4,
    backgroundTopSpacing: 30,
    animationDuration: 4,
    animationType: 'crazyShake',
  },

  {
    id: 3,
    key: 'theme-3',
    name: 'Theme 3',
    description: 'Luxury Gold & Midnight Spin Wheel',

    wheelColors: [
      '#FFFFFF',
      '#D4AF37',
      '#FFFFFF',
      '#F3D27A',
      '#FFFFFF',
      '#B8860B',
      '#FFFFFF',
      '#FFE6A3',
      '#FFFFFF',
      '#C99A2E',
    ],

    backgroundColor: '#FFFFFF',
    patternBackground: '#e5dcc6b0',

    backgroundText:
      'LUCKY!  GOLD!  WIN!  LUCKY!  GOLD!  WIN!',

    backgroundTextColor: '#1f1907',
    backgroundTextOpacity: 0.07,
    backgroundFontSize: '145px',
    backgroundRows: 4,
    backgroundTopSpacing: 27,
    animationDuration: 6,
    animationType: 'luxuryFloat',
  },

  {
    id: 4,
    key: 'theme-4',
    name: 'Theme 4',
    description: 'Golden Casino Roulette Spin Wheel',

    wheelColors: [
      '#C68A4A',
      '#F4D7A1',
      '#8B5A2B',
      '#E8BD79',
      '#6E3F1D',
      '#F2D09A',
      '#A96832',
      '#D9A85B',
      '#75451F',
      '#EFCB91',
    ],

    backgroundColor: '#B9824A',

    patternBackground:
      'radial-gradient(circle at 50% 45%, #F3D4A0 0%, #D6A064 35%, #B47742 68%, #8D572E 100%)',

    backgroundText:
      'JACKPOT!  WIN!  LUCKY!  500!  100!  JACKPOT!',

    backgroundTextColor: '#332f23',
    backgroundTextOpacity: 0.09,
    backgroundFontSize: '125px',
    backgroundRows: 4,
    backgroundTopSpacing: 5,
    animationDuration:2,
    animationType: 'goldenCasino',
  },

  {
    id: 5,
    key: 'theme-5',
    name: 'Theme 5',
    description: 'Deep Space Galaxy Spin Wheel',

    wheelColors: [
      '#2563EB',
      '#FFFFFF',
      '#2563EB',
      '#FFFFFF',
      '#2563EB',
      '#FFFFFF',
      '#2563EB',
      '#FFFFFF',
      '#2563EB',
      '#FFFFFF',

    ],

    backgroundColor: '#02010B',

    /*
      ========================================================
      ALL STARS & GALAXY EMBEDDED IN PATTERN BACKGROUND
      ========================================================
      Frontend par changes ki zaroorat nahi, ye massive string
      stars, dust, aur galaxy ko direct render karegi.
    */
    patternBackground:

    'radial-gradient(circle at 25% 15%, rgba(255,255,255,0.8) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 80% 10%, rgba(255,255,255,0.9) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 90% 40%, rgba(255,255,255,0.7) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 75% 75%, rgba(255,255,255,0.9) 2px, transparent 2.5px), ' +
      'radial-gradient(circle at 15% 85%, rgba(255,255,255,0.8) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 45% 90%, rgba(255,255,255,0.9) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 50% 5%, rgba(255,255,255,0.7) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 65% 55%, rgba(255,255,255,0.9) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 35% 65%, rgba(255,255,255,0.8) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 5% 50%, rgba(255,255,255,0.9) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 95% 80%, rgba(255,255,255,0.7) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 20% 40%, rgba(255,255,255,0.8) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 85% 25%, rgba(255,255,255,0.9) 2px, transparent 2.5px), ' +
      'radial-gradient(circle at 40% 30%, rgba(255,255,255,0.7) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 60% 85%, rgba(255,255,255,0.9) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 30% 75%, rgba(255,255,255,0.8) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 70% 35%, rgba(255,255,255,0.9) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 55% 20%, rgba(255,255,255,0.7) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 12% 60%, rgba(255,255,255,0.9) 2px, transparent 2.5px), ' +
      'radial-gradient(circle at 88% 60%, rgba(255,255,255,0.8) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 48% 45%, rgba(255,255,255,0.9) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 28% 95%, rgba(255,255,255,0.7) 1px, transparent 1.5px), ' +
      'radial-gradient(circle at 82% 95%, rgba(255,255,255,0.9) 1.5px, transparent 2px), ' +
      'radial-gradient(circle at 31% 61%, rgba(255,255,255,1) 0px, rgba(139,92,246,0.6) 4px, transparent 15px), ' +
      'radial-gradient(circle at 52% 35%, rgba(255,255,255,1) 0px, rgba(34,211,238,0.6) 3px, transparent 12px), ' +
      'radial-gradient(circle at 74% 72%, rgba(255,255,255,1) 0px, rgba(124,58,237,0.6) 4px, transparent 15px), ' +
      'radial-gradient(circle at 36% 46%, rgba(255,255,255,1) 0px, rgba(147,51,234,0.6) 5px, transparent 18px), ' +
      'radial-gradient(circle at 33% 52%, rgba(255,255,255,0.98) 0%, rgba(236,227,255,0.90) 2%, rgba(191,144,255,0.82) 6%, rgba(140,74,255,0.72) 12%, rgba(101,39,208,0.52) 22%, rgba(54,25,128,0.28) 35%, transparent 54%), ' +
      'radial-gradient(ellipse at 48% 34%, rgba(29,180,232,0.32) 0%, rgba(31,116,190,0.22) 18%, transparent 46%), ' +
      'radial-gradient(ellipse at 71% 23%, rgba(57,214,191,0.28) 0%, rgba(27,150,170,0.12) 22%, transparent 48%), ' +
      'radial-gradient(ellipse at 12% 78%, rgba(72,91,255,0.32) 0%, rgba(79,36,180,0.14) 28%, transparent 52%), ' +
      'radial-gradient(ellipse at 79% 72%, rgba(155,63,255,0.30) 0%, rgba(97,27,177,0.10) 28%, transparent 55%), ' +
      'linear-gradient(135deg, #010107 0%, #03020D 26%, #08021B 53%, #02010A 100%)',

    backgroundText:
      'LUCKY!  WIN!  JACKPOT!  SPIN!  LUCKY!',

    backgroundTextColor: '#DDD6FE',
    backgroundTextOpacity: 0.025,
    backgroundFontSize: '120px',
    backgroundRows: 4,
    backgroundTopSpacing: 27,
    animationDuration: 10,
    animationType: 'cosmicDrift',
    cosmicGlow: true,
    cosmicAnimation: true,
  },
];

/*
  ============================================================
  SMALL PREVIEW WHEEL
  ============================================================
*/
const ThemePreviewWheel = ({ theme }) => {
  const segmentCount = theme.wheelColors.length;
  const segmentAngle = 360 / segmentCount;

  const gradientParts = theme.wheelColors.map(
    (color, index) => {
      const start = index * segmentAngle;
      const end = (index + 1) * segmentAngle;
      return `${color} ${start}deg ${end}deg`;
    }
  );

  const centerButtonBackground =
    theme.id === 2
      ? '#9E0000'
      : theme.id === 3
        ? 'linear-gradient(135deg, #FFF2B2, #D4AF37, #8F6B14)'
        : theme.id === 4
          ? 'radial-gradient(circle at 35% 30%, #FFF4D1 0%, #D8A45D 42%, #8A5429 100%)'
          : theme.id === 5
            ? 'radial-gradient(circle at 32% 25%, #FFFFFF 0%, #C7D2FE 18%, #60A5FA 38%, #2563EB 62%, #312E81 100%)'
            : '#2563EB';

  const wheelBorder =
    theme.id === 2
      ? '#9E0000'
      : theme.id === 3
        ? '#D4AF37'
        : theme.id === 4
          ? '#7B4A25'
          : theme.id === 5
            ? '#DBEAFE'
            : '#FFFFFF';

  const wheelOuterBackground =
    theme.id === 3
      ? 'linear-gradient(135deg, #FFFFFF, #F6F1E7, #D4AF37)'
      : theme.id === 4
        ? 'linear-gradient(135deg, #FCE7B2, #C98A4B, #70421F, #E6B96F)'
        : theme.id === 5
          ? 'linear-gradient(135deg, #FFFFFF, #BFDBFE, #60A5FA, #4F46E5, #7C3AED)'
          : '#FFFFFF';

  const wheelShadow =
    theme.id === 3
      ? '0 16px 45px rgba(212,175,55,0.30)'
      : theme.id === 4
        ? '0 18px 45px rgba(91,52,23,0.38), 0 0 20px rgba(245,201,126,0.35)'
        : theme.id === 5
          ? '0 18px 50px rgba(37,99,235,0.48), 0 0 35px rgba(124,58,237,0.50), 0 0 70px rgba(6,182,212,0.18)'
          : '0 16px 35px rgba(15,23,42,0.18)';

  return (
    <div
      className="relative w-36 h-36 sm:w-40 sm:h-40"
      style={{
        animation: theme.id === 5 ? 'cosmicWheelFloat 5s ease-in-out infinite' : undefined,
      }}
    >
      <div
        className="absolute inset-0 rounded-full p-2"
        style={{
          background: wheelOuterBackground,
          boxShadow: wheelShadow,
        }}
      >
        <div
          className="w-full h-full rounded-full relative overflow-hidden"
          style={{
            background: `conic-gradient(${gradientParts.join(', ')})`,
            border: theme.id === 5 ? '6px solid #DBEAFE' : `6px solid ${wheelBorder}`,
            boxShadow: theme.id === 5 ? 'inset 0 0 22px rgba(30,64,175,0.40)' : undefined,
          }}
        >
          {theme.id === 4 && (
            <div
              className="absolute inset-[7px] rounded-full pointer-events-none"
              style={{
                border: '2px solid rgba(255,241,199,0.70)',
                boxShadow: 'inset 0 0 12px rgba(91,52,23,0.35)',
              }}
            />
          )}
          {theme.id === 4 &&
            Array.from({ length: 10 }).map((_, index) => {
              const angle = index * 36 - 90;
              const radius = 43;
              const x = 50 + Math.cos((angle * Math.PI) / 180) * (radius / 2);
              const y = 50 + Math.sin((angle * Math.PI) / 180) * (radius / 2);
              return (
                <span
                  key={`light-${index}`}
                  className="absolute rounded-full"
                  style={{
                    width: '6px',
                    height: '6px',
                    left: `${x}%`,
                    top: `${y}%`,
                    transform: 'translate(-50%, -50%)',
                    background: 'radial-gradient(circle at 35% 30%, #FFFFFF 0%, #FFD978 45%, #B76B27 100%)',
                    boxShadow: '0 0 8px rgba(255,220,137,0.95)',
                  }}
                />
              );
            })}
          {theme.id === 5 && (
            <>
              <div
                className="absolute inset-0 pointer-events-none rounded-full"
                style={{
                  background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.26) 0%, transparent 48%)',
                  animation: 'cosmicWheelGlow 3.2s ease-in-out infinite',
                }}
              />
              <div
                className="absolute inset-[8px] rounded-full pointer-events-none"
                style={{
                  border: '2px solid rgba(255,255,255,0.72)',
                  boxShadow: 'inset 0 0 20px rgba(96,165,250,0.38)',
                }}
              />
            </>
          )}
        </div>
      </div>

      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full flex items-center justify-center text-white font-black text-xs shadow-lg"
        style={{
          background: centerButtonBackground,
          border: theme.id === 4 ? '3px solid #F7D68D' : theme.id === 3 ? '2px solid #FFF1AD' : theme.id === 5 ? '3px solid #E0F2FE' : 'none',
          boxShadow: theme.id === 3 ? '0 0 25px rgba(212,175,55,0.45)' : theme.id === 4 ? '0 0 22px rgba(231,184,109,0.55), inset 0 0 10px rgba(255,245,211,0.40)' : theme.id === 5 ? '0 0 25px rgba(96,165,250,0.85), 0 0 45px rgba(124,58,237,0.55), 0 0 70px rgba(34,211,238,0.20), inset 0 0 12px rgba(255,255,255,0.50)' : '0 8px 20px rgba(0,0,0,0.2)',
        }}
      >
        SPIN
      </div>

      {theme.id === 4 && (
        <>
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: '-5px',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '13px solid #7A1C12',
              filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.30))',
              zIndex: 10,
            }}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: '0px',
              width: '6px',
              height: '7px',
              background: '#B53B25',
              borderRadius: '0 0 4px 4px',
              zIndex: 11,
            }}
          />
        </>
      )}

      {theme.id === 5 && (
        <>
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: '-5px',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '13px solid #172554',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.45))',
              zIndex: 15,
            }}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: '0px',
              width: '5px',
              height: '7px',
              borderRadius: '0 0 5px 5px',
              background: '#60A5FA',
              boxShadow: '0 0 6px rgba(96,165,250,0.9)',
              zIndex: 16,
            }}
          />
        </>
      )}
    </div>
  );
};

/*
  ============================================================
  BACKGROUND PREVIEW
  ============================================================
*/
const BackgroundPreview = ({ theme }) => {
  const rows = useMemo(
    () => Array.from({ length: theme.backgroundRows }, (_, i) => i),
    [theme.backgroundRows]
  );

  const getAnimationName = () => {
    switch (theme.animationType) {
      case 'luxuryFloat': return 'luxuryFloat';
      case 'goldenCasino': return 'goldenCasino';
      case 'cosmicDrift': return 'cosmicDrift';
      case 'crazyShake':
      default: return 'crazyShake';
    }
  };

  const getPatternOpacity = () => {
    if (theme.id === 3) return 0.65;
    if (theme.id === 4) return 0.80;
    if (theme.id === 5) return 1;
    return 1;
  };

  return (
    <div
      className="relative h-full w-full overflow-hidden"
      style={{
        background: theme.patternBackground,
      }}
    >
      {theme.id === 3 && (
        <>
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'radial-gradient(circle at center, rgba(212,175,55,0.12), transparent 55%)',
            }}
          />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'linear-gradient(115deg, transparent 20%, rgba(212,175,55,0.08) 45%, transparent 70%)',
              animation: 'luxurySweep 7s ease-in-out infinite',
            }}
          />
        </>
      )}

      {theme.id === 4 && (
        <>
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'radial-gradient(circle at 50% 50%, rgba(255,229,179,0.35), transparent 48%)',
              animation: 'casinoGlow 4s ease-in-out infinite',
            }}
          />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'linear-gradient(115deg, transparent 15%, rgba(255,239,189,0.20) 45%, transparent 75%)',
              animation: 'casinoSweep 6s linear infinite',
            }}
          />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'radial-gradient(circle, transparent 35%, rgba(91,52,23,0.15) 100%)',
            }}
          />
        </>
      )}

      {rows.map((i) => (
        <div
          key={`${theme.key}-${i}`}
          style={{
            position: 'absolute',
            top: `${i * theme.backgroundTopSpacing}%`,
            left: '-5%',
            width: '110%',
            textAlign: 'center',
            animation: `${getAnimationName()} ${theme.animationDuration + i}s ease-in-out infinite`,
            animationDelay: `${i * 0.2}s`,
            opacity: theme.backgroundTextOpacity,
            pointerEvents: 'none',
            filter: theme.id === 3 ? 'drop-shadow(0 0 8px rgba(212,175,55,0.12))' : theme.id === 4 ? 'drop-shadow(0 0 12px rgba(255,216,143,0.25))' : theme.id === 5 ? 'drop-shadow(0 0 15px rgba(167,139,250,0.25))' : 'none',
            zIndex: theme.id === 5 ? 5 : 1,
          }}
        >
          <span
            style={{
              fontSize: theme.backgroundFontSize,
              fontWeight: 900,
              color: theme.backgroundTextColor,
              letterSpacing: theme.id === 4 ? '2px' : theme.id === 5 ? '3px' : '1px',
              wordSpacing: theme.id === 4 ? '15px' : theme.id === 5 ? '18px' : '10px',
              fontFamily: "'Century Gothic', sans-serif",
              userSelect: 'none',
              whiteSpace: 'nowrap',
              display: 'inline-block',
              opacity: getPatternOpacity(),
            }}
          >
            {theme.backgroundText}
          </span>
        </div>
      ))}

      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{
          zIndex: theme.id === 5 ? 10 : 5,
        }}
      >
        <ThemePreviewWheel theme={theme} />
      </div>
    </div>
  );
};

const ThemeManager = () => {
  const [themes, setThemes] = useState(THEMES);
  const [activeThemeKey, setActiveThemeKey] = useState(() => {
    if (typeof window === 'undefined') return 'theme-1';
    return localStorage.getItem('activeThemeKey') || 'theme-1';
  });
  const [loading, setLoading] = useState(true);
  const [activating, setActivating] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadThemes = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await api.get('/api/themes');
        const serverThemes = Array.isArray(response?.data) ? response.data : Array.isArray(response?.data?.data) ? response.data.data : [];
        if (!cancelled && serverThemes.length > 0) {
          setThemes(
            serverThemes.map((serverTheme) => {
              const localTheme = THEMES.find((theme) => theme.key === serverTheme.themeKey) || {};
              return { ...localTheme, ...serverTheme };
            })
          );
        }
      } catch (err) {
        console.warn('Could not load themes from backend:', err);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    const loadActiveTheme = async () => {
      try {
        const response = await api.get('/api/themes/active');
        const key = response?.data?.themeKey || response?.data?.data?.themeKey;
        if (!cancelled && key) {
          const exists = THEMES.some((theme) => theme.key === key);
          if (exists) {
            setActiveThemeKey(key);
            localStorage.setItem('activeThemeKey', key);
          }
        }
      } catch (err) {
        console.warn('Could not load active theme:', err);
      }
    };

    loadThemes();
    loadActiveTheme();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleActivate = async (theme) => {
    if (!theme?.id || activating !== null) return;

    setActivating(theme.id);
    setMessage('');
    setError('');

    try {
      await api.put(`/api/themes/${theme.id}/activate`);
      setActiveThemeKey(theme.key);
      localStorage.setItem('activeThemeKey', theme.key);
      setThemes((currentThemes) =>
        currentThemes.map((item) => ({
          ...item,
          isActive: item.key === theme.key,
        }))
      );
      setMessage(`${theme.name} is now active.`);
    } catch (err) {
      setActiveThemeKey(theme.key);
      localStorage.setItem('activeThemeKey', theme.key);
      setThemes((currentThemes) =>
        currentThemes.map((item) => ({
          ...item,
          isActive: item.key === theme.key,
        }))
      );
      setMessage(`${theme.name} selected on this device. Backend activation could not be confirmed yet.`);
      setError(err?.response?.data?.message || 'Backend theme activation is not available yet.');
    } finally {
      setActivating(null);
      setTimeout(() => {
        setMessage('');
        setError('');
      }, 3500);
    }
  };

  const activeTheme = themes.find((theme) => theme.key === activeThemeKey || theme.isActive === true) || THEMES[0];

  return (
    <>
      <style>
        {`
          @keyframes crazyShake {
            0% { transform: scale(1) skewY(-8deg) translate(0,0); }
            25% { transform: scale(1.1) skewY(-8deg) translate(10px,-10px); }
            50% { transform: scale(1.2) skewY(-8deg) translate(-10px,10px); }
            75% { transform: scale(1.1) skewY(-8deg) translate(10px,10px); }
            100% { transform: scale(1) skewY(-8deg) translate(0,0); }
          }
          @keyframes luxuryFloat {
            0% { transform: translate3d(0,0,0) scale(1) rotate(-2deg); }
            25% { transform: translate3d(18px,-12px,0) scale(1.04) rotate(1deg); }
            50% { transform: translate3d(-10px,12px,0) scale(1.08) rotate(-1deg); }
            75% { transform: translate3d(14px,5px,0) scale(1.04) rotate(2deg); }
            100% { transform: translate3d(0,0,0) scale(1) rotate(-2deg); }
          }
          @keyframes luxurySweep {
            0% { transform: translateX(-120%) skewX(-15deg); }
            50% { transform: translateX(30%) skewX(-15deg); }
            100% { transform: translateX(140%) skewX(-15deg); }
          }
          @keyframes goldenCasino {
            0% { transform: translate3d(0,0,0) scale(1) rotate(-1.5deg); }
            20% { transform: translate3d(9px,-7px,0) scale(1.025) rotate(1deg); }
            40% { transform: translate3d(-8px,7px,0) scale(1.05) rotate(-0.5deg); }
            60% { transform: translate3d(8px,4px,0) scale(1.035) rotate(1deg); }
            80% { transform: translate3d(-5px,-4px,0) scale(1.02) rotate(-1deg); }
            100% { transform: translate3d(0,0,0) scale(1) rotate(-1.5deg); }
          }
          @keyframes casinoGlow {
            0% { opacity: 0.35; transform: scale(0.96); }
            50% { opacity: 0.75; transform: scale(1.08); }
            100% { opacity: 0.35; transform: scale(0.96); }
          }
          @keyframes casinoSweep {
            0% { transform: translateX(-120%) skewX(-12deg); }
            50% { transform: translateX(10%) skewX(-12deg); }
            100% { transform: translateX(120%) skewX(-12deg); }
          }
          @keyframes cosmicDrift {
            0% { transform: translate3d(0,0,0) scale(1) rotate(-1deg); }
            25% { transform: translate3d(15px,-9px,0) scale(1.025) rotate(0deg); }
            50% { transform: translate3d(-14px,11px,0) scale(1.05) rotate(1deg); }
            75% { transform: translate3d(10px,5px,0) scale(1.025) rotate(0deg); }
            100% { transform: translate3d(0,0,0) scale(1) rotate(-1deg); }
          }
          @keyframes cosmicWheelFloat {
            0% { transform: translateY(0) scale(1); }
            50% { transform: translateY(-4px) scale(1.015); }
            100% { transform: translateY(0) scale(1); }
          }
          @keyframes cosmicWheelGlow {
            0% { opacity: 0.30; }
            50% { opacity: 0.75; }
            100% { opacity: 0.30; }
          }
        `}
      </style>

      <div className="min-h-full bg-slate-50">
        <div className="max-w-7xl mx-auto">
          {/* HEADER */}
          <div className="mb-8">
            <div className="flex items-center gap-4">
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-sm"
                style={{ background: 'linear-gradient(135deg,#7C3AED,#A78BFA)' }}
              >
                <span className="text-2xl">🎨</span>
              </div>
              <div>
                <h1 className="text-3xl font-bold text-slate-900">Theme Manager</h1>
                <p className="text-sm text-slate-500 mt-1">Select the appearance for the customer Spin Wheel.</p>
              </div>
            </div>
          </div>

          {/* CURRENT ACTIVE */}
          <div className="mb-8 rounded-3xl border border-emerald-200 bg-white p-6 shadow-sm">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />
                  <p className="text-xs uppercase tracking-[0.18em] text-emerald-700 font-bold">Currently Active</p>
                </div>
                <h2 className="text-2xl font-bold text-slate-900">{activeTheme?.name || 'Theme 1'}</h2>
                <p className="text-sm text-slate-500 mt-1">{activeTheme?.description || ''}</p>
              </div>
              <div className="px-4 py-2 rounded-full bg-emerald-50 border border-emerald-200">
                <span className="text-sm font-bold text-emerald-700">ACTIVE</span>
              </div>
            </div>
          </div>

          {message && (
            <div className="mb-5 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4">
              <p className="text-sm font-semibold text-emerald-800">✓ {message}</p>
            </div>
          )}

          {error && (
            <div className="mb-5 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4">
              <p className="text-sm font-semibold text-amber-800">{error}</p>
            </div>
          )}

          {loading && (
            <div className="mb-5 rounded-2xl border border-slate-200 bg-white px-5 py-4">
              <p className="text-sm text-slate-500">Loading theme settings...</p>
            </div>
          )}

          {/* THEMES GRID */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-7">
            {themes.map((theme) => {
              const isActive = theme.key === activeThemeKey;
              return (
                <div
                  key={theme.id}
                  className={`
                    overflow-hidden rounded-3xl bg-white border transition-all duration-300
                    ${isActive ? 'border-emerald-400 shadow-xl' : 'border-slate-200 shadow-sm hover:shadow-lg'}
                  `}
                >
                  {/* PREVIEW CONTAINER */}
                  <div className="relative h-72 overflow-hidden bg-slate-900">
                    <BackgroundPreview theme={theme} />
                    {isActive && (
                      <div className="absolute top-4 right-4 z-30">
                        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur-sm shadow-md border border-emerald-200">
                          <span className="w-2 h-2 rounded-full bg-emerald-500" />
                          <span className="text-xs font-bold text-emerald-700">ACTIVE</span>
                        </div>
                      </div>
                    )}
                    <div className="absolute top-4 left-4 z-30">
                      <div className="px-3 py-1.5 rounded-full bg-black/50 text-white text-xs font-bold backdrop-blur-sm">
                        THEME {theme.id}
                      </div>
                    </div>
                  </div>

                  {/* DETAILS */}
                  <div className="p-6">
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <h3 className="text-xl font-bold text-slate-900">{theme.name}</h3>
                        <p className="text-sm text-slate-500 mt-1">{theme.description}</p>
                      </div>
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center border bg-slate-50 border-slate-200">
                        <span className="text-lg">🎯</span>
                      </div>
                    </div>

                    <div className="mt-5">
                      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Wheel Colors</p>
                      <div className="flex items-center gap-1.5 flex-wrap">
                        {theme.wheelColors.map((color, index) => (
                          <div
                            key={`${theme.key}-${index}`}
                            title={color}
                            className="w-7 h-7 rounded-lg border border-slate-200 shadow-sm"
                            style={{ background: color }}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="mt-5 grid grid-cols-2 gap-3">
                      <div className="rounded-2xl bg-slate-50 border border-slate-100 p-3">
                        <p className="text-[11px] uppercase tracking-wider text-slate-400 font-bold">Background</p>
                        <div className="flex items-center gap-2 mt-2">
                          <div
                            className="w-5 h-5 rounded-md border border-slate-200"
                            style={{ background: theme.patternBackground }}
                          />
                          <span className="text-xs font-semibold text-slate-700 truncate">
                            {theme.id === 5 ? 'Galaxy Cosmic' : typeof theme.patternBackground === 'string' ? theme.patternBackground : 'Premium Gradient'}
                          </span>
                        </div>
                      </div>
                      <div className="rounded-2xl bg-slate-50 border border-slate-100 p-3">
                        <p className="text-[11px] uppercase tracking-wider text-slate-400 font-bold">Pattern</p>
                        <p className="text-xs font-semibold text-slate-700 mt-2 truncate">
                          {theme.backgroundText}
                        </p>
                      </div>
                    </div>

                    <button
                      type="button"
                      disabled={isActive || activating !== null}
                      onClick={() => handleActivate(theme)}
                      className={`
                        mt-6 w-full rounded-2xl py-3.5 text-sm font-bold transition-all duration-200
                        ${isActive ? 'bg-emerald-50 text-emerald-700 border border-emerald-200 cursor-default' : 'bg-slate-900 text-white hover:bg-slate-800 active:scale-[0.99]'}
                        ${activating === theme.id ? 'opacity-70 cursor-wait' : ''}
                      `}
                    >
                      {activating === theme.id ? 'Activating...' : isActive ? '✓ Active Theme' : 'Activate Theme'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-8 rounded-2xl border border-blue-200 bg-blue-50 p-5">
            <p className="text-sm font-bold text-blue-900">Theme switching works</p>
            <p className="text-sm text-blue-800 mt-1 leading-6">
              Choose any theme above to change the customer Spin Wheel appearance.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThemeManager;